<p lang="en" align="center">
    <strong>The Personal Data Protection and Privacy Policy</strong>
</p>
<p lang="en">
    The purpose of the personal data protection policy is to inform individuals, users of services, associates, employees and other persons (hereinafter referred to as "individuals") who participate with <strong>Table42 Ltd</strong>, Vurnikov trg 3, 4240 Radovljica (hereinafter referred to as "the company") about the purposes, legal bases, security measures and rights of individuals regarding the processing of personal data carried out by our company.
</p>
<p lang="en">
    The company is the owner of the following websites/portals/applications:
</p>
<p lang="en">
    <strong>table42.app</strong>
</p>
<p lang="en">
    <strong>www.</strong>
    <strong>table42.app</strong>
    <strong></strong>
</p>
<p lang="en">
    <strong>table42.app application</strong>
</p>
<p lang="en">
    <strong>
        We value your privacy and always carefully protect your data.
    </strong>
</p>
<p lang="en">
    We process personal data in accordance with European legislation (Regulation (EU) 2016/697 on the protection of individuals with regard to the processing of personal data and on the free movement of such data (hereinafter referred to as the "General Regulation")), applicable Slovenian legislation on the protection of personal data and other legislation that gives us legal grounds for the processing of personal data.
</p>
<p lang="en">
    The personal data protection policy contains information on how our company as a controller processes personal data that it receives from an individual on the basis of the legal grounds described below.
</p>
<h1 lang="en">
    1) Controller
</h1>
<p lang="en">
    The controller of personal data is the company:
</p>
<p lang="en">
    <strong>Table42 Ltd</strong>
</p>
<p lang="en">
    Vurnikov trg 3, 4240 Radovljica
</p>
<p lang="en">
    E-mail: stik@table42.app
</p>
<p lang="en">
    Phone: +386 31312038
</p>
<h1 lang="en">
    2) Contact person for personal data protection
</h1>
<p lang="en">
    Individuals to whom the personal data relate can contact the contact person for personal data protection with any questions related to the processing of their personal data and the exercise of their rights under the General Regulation by email: <em>stik@table42.app</em>
</p>
<h1 lang="en">
    3) Personal data
</h1>
<p lang="en">
    Personal data means any information relating to an identified or identifiable natural person; an identifiable natural person is one who can be directly or indirectly identified, in particular by reference to an identifier such as a name, identification number, location data, online identifier, or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person.
</p>
<h1 lang="en">
    4) Purposes of processing and legal basis for processing data
</h1>
<p lang="en">
    The company collects and processes your personal data on the following legal grounds:
</p>
<ul>
    <li>
        <p lang="en">
processing is necessary for the fulfillment of a <strong>legal obligation</strong> that applies to the controller;
        </p>
    </li>
    <li>
        <p lang="en">
            processing is necessary for the <strong>performance of a contract</strong> of which the data subject is a party, or for the performance of pre-contractual measures taken at the data subject's request;
        </p>
    </li>
    <li>
        <p lang="en">
processing is necessary for the <strong>legitimate interests</strong> pursued by the controller or by a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of the data subject;
        </p>
    </li>
    <li>
        <p lang="en">
the data subject has <strong>given consent</strong>  to the processing of his or her personal data for one or more specific purposes;
        </p>
    </li>
    <li>
        <p lang="en">
processing is necessary for <strong>the protection of the vital interests</strong> of the data subject or of another natural person.
        </p>
    </li>
</ul>
<p lang="en">
    <strong>4.1) Fulfillment of legal obligations</strong>
</p>
<p lang="en">
    Based on provisions in the law, the company processes data about its employees, which allows it to comply with labor and social security legislation. For the purposes of employment, the company primarily processes the following types of personal data: name and surname, gender, date of birth, personal identification number, place, municipality and country of birth, citizenship, place of residence, etc.
</p>
<p lang="en">
    <strong>4.2) Performance of a contract</strong>
</p>
<p lang="en" align="justify">
    If you enter into a contract with the company as an individual, this represents the legal basis for the processing of personal data. The contract provides you with many benefits.
</p>
<p lang="en" align="justify">
    By beginning to use our services, you confirm that you have read and fully understand the General Terms and Conditions, which are an integral part of the contract.
</p>
<p lang="en" align="justify">
    <br/>
    We will process the personal data that you provide to us or that is provided to us by third parties on your request for the purpose of securing your rights under this contract, for the purpose of verifying compliance with the General Terms and Conditions, for the purpose of assessing the offer, optimizing the offers and costs and improving customer satisfaction, for resolving your questions, proposals, objections or complaints, and for informing you of technical, legal and other issues. Occasionally we will ask you for feedback on your satisfaction with the use of our service. We will process the data for the purpose of preparing special offers and inform you about them in the way you have chosen (by e-mail, SMS, or in the application). If the data subject does not provide the personal data, the company cannot conclude the contract, nor can it perform the services or deliver the goods in accordance with the contract, as it does not have the necessary data to do so.
</p>
<p lang="en" align="justify">
    <a name="_Hlk39669227"></a>
    <br/>
    We may process your personal data for the conclusion and performance of the contract, such as the sale of goods and services, membership in benefit clubs, participation in events, training, promotions, etc. Based on its legitimate activity, the company can inform individuals and users of its services by e-mail about its services, events, training, offers and other content. The data subject may at any time request the termination of such communication and processing of personal data and the cancellation of receiving messages via the unsubscribe link in the received message, or by request by e-mail at <em>stik@table42.app</em>  or by regular mail at the company's address.
<p lang="en">
    <strong>4.3) Legitimate interest</strong>
</p>
<p lang="en">
    The company may also process personal data on the basis of a legitimate interest pursued by the company. This is not permitted if such interests are overridden by the interests or fundamental rights and freedoms of the individual whose personal data is concerned, which require the protection of personal data. In the case of the use of legitimate interest, the company always carries out an assessment in accordance with the General Data Protection Regulation.
</p>
<p lang="en">
    The processing of personal data of individuals for the purpose of direct marketing is considered to be carried out in the legitimate interest of the company. The company may process personal data of individuals that it has collected from publicly available sources or in the course of its lawful business activities, also for the purpose of offering goods, services, employment, informing about benefits, events, etc. For these purposes, the company may use ordinary mail, telephone calls, email and other telecommunications means. For the purpose of direct marketing, the company may process the following personal data of individuals: name and surname of the individual, address of permanent or temporary residence, telephone number and email address. The aforementioned personal data may also be processed by the company for the purpose of direct marketing without the express consent of the individual. The individual may at any time request the termination of such communication and processing of personal data and withdraw from receiving messages via the unsubscribe link in the received message, or as a request by email to <em>stik@table42.app</em>  or by regular mail to the address of the company.
</p>
<p lang="en">
    <strong>4.4) Processing based on consent or agreement</strong>
</p>
<p lang="en">
    If the company does not have a legal basis established on the basis of law, contractual obligations or legitimate interest, it may ask the individual for consent or agreement. In this way, it may also process certain personal data of the individual for the following purposes, if the individual gives consent for this:
</p>
<ul>
    <li>
        <p lang="en">
            residential address and email address for the purpose of informing and communication;
        </p>
    </li>
    <li>
        <p lang="en">
            other purposes for which the individual agrees with the consent.
        </p>
    </li>
</ul>
<p lang="en">
    If an individual gives consent for the processing of personal data and no longer wishes to do so at some point, they may request the termination of the processing of personal data with a request by email to <em>stik@table42.app</em>  or by regular mail to the address of the company. The withdrawal of consent does not affect the lawfulness of the processing based on consent before its withdrawal.
</p>
<p lang="en">
    <strong>
        4.5) Processing is necessary to protect the vital interests of the individual
    </strong>
</p>
<p lang="en">
    The company may process the personal data of the individual to whom the personal data relates, if this is necessary to protect their vital interests. In urgent cases, the company may search for the personal document of the individual, verify whether the individual exists in its database, study their medical history or contact their relatives, for which the company does not need the consent of the individual. This applies in cases where it is necessary to protect the vital interests of the individual.
</p>
<h1 lang="en">
    5) Storage and deletion of personal data
</h1>
<p lang="en">
    The company will store personal data only for as long as is necessary to fulfill the purpose for which the personal data was collected and processed. If the company processes the data on the basis of a law, it will store the data for the period prescribed by law. Some data will be stored for the duration of the company's relationship with the individual, while other data must be stored indefinitely.
</p>
<p lang="en">
    Personal data that the company processes on the basis of a contract with an individual will be stored for the period necessary to fulfill the contract and for an additional 6 years after the contract has ended, unless there is a dispute between the individual and the company regarding the contract. In such cases, the company will store the data for 10 years after the final judgment, arbitration or settlement of the dispute, or, if there is no dispute, for 5 years from the date of peaceful resolution of the dispute. Personal data that the company processes on the basis of the individual's personal consent or legitimate interest will be stored until the consent is withdrawn or a request for deletion of the data is made. Upon receipt of a request for withdrawal of consent or deletion of data, the data will be deleted without undue delay, but in any case within one month of receipt of the request. This deadline may be extended by a maximum of two additional months if necessary, taking into account the complexity and number of requests. The organization will inform the individual whose personal data is concerned about any such extension within one month of receipt of the request, along with the reasons for the delay. An exception applies to those personal data whose retention period is prescribed by law. The company may also delete these data before the withdrawal, if the purpose of processing the personal data has been achieved or if so prescribed by law.
</p>
<p lang="en">
    In exceptional cases, the company may refuse a request for deletion for reasons provided in the General Regulation, such as the exercise of the right to freedom of expression and information, the fulfillment of legal obligations for processing, public health reasons, public interest archiving, scientific or historical research purposes or statistical purposes, or the exercise or defense of legal claims. After the retention period has expired, the company must effectively and permanently delete or anonymize the personal data so that it is no longer possible to associate it with a specific individual.
</p>
<h1 lang="en">
    6) Contractual processing of personal data and data transfer
</h1>
<p lang="en">
    The company may entrust the processing of certain personal data to a subcontractor on the basis of a contract for contractual processing. Subcontractors may process the entrusted data exclusively on behalf of the controller, within the scope of its authority specified in the written contract or other legal act and in accordance with the purposes specified in this privacy policy.
</p>
<p lang="en">
    The subcontractors with which the company cooperates include:
</p>
<ul>
    <li>
        <p lang="en">
            accounting services and other providers of legal and business advice;
        </p>
    </li>
    <li>
        <p lang="en">
            infrastructure maintenance (video surveillance, security services);
        </p>
    </li>
    <li>
        <p lang="en">
            information systems maintenance;
        </p>
    </li>
    <li>
        <p lang="en">
            e-mail service providers and software and cloud service providers (e.g. Arnes, Microsoft, Google);
        </p>
    </li>
    <li>
        <p lang="en">
            social networking and online advertising providers (Google, Facebook, Instagram, etc.).
        </p>
    </li>
</ul>
<p lang="en">
    In no case will the company transfer the personal data of an individual to third unauthorized parties. Subcontractors may only process personal data within the instructions of the company and may not use personal data for any other purposes.
</p>
<p lang="en">
    The company, as the controller, and its employees do not transfer personal data to third countries (countries outside the member states of the European Economic Area - EU member states, Iceland, Norway and Liechtenstein) and international organizations, except to the United States, where subcontractors from the United States are included in the EU-US Privacy Shield program. More about the EU-US Privacy Shield can be found on the website of the Information Commissioner:
    <u>
        <a
            href="https://www.ip-rs.si/varstvo-osebnih-podatkov/obveznosti-upravljavcev/iznos-osebnih-podatkov-v-tretje-drzave/iznos-osebnih-podatkov-v-zda/"
        >
            https://www.ip-rs.si/varstvo-osebnih-podatkov/obveznosti-upravljavcev/iznos-osebnih-podatkov-v-tretje-drzave/iznos-osebnih-podatkov-v-zda/
        </a>
    </u>
    .
</p>
<h1 lang="en">
    7) Cookies
</h1>
<p lang="en">
    The company's website operates with the help of so-called cookies (angl. cookies). A cookie is a file that stores website settings. Websites save cookies on the user's devices, which access the internet in order to recognize individual devices and the settings that users have used to access them. Cookies allow websites to recognize if a user has already visited the website. In advanced applications, they can be used to appropriately adjust individual settings. Their storage is completely under the control of the browser used by the individual - this can restrict or disable cookie storage as desired.
</p>
<p lang="en">
    Cookies are essential for providing user-friendly online services. They are used to store data on the status of an individual website, help collect statistics on users and website visits, etc. We use cookies to assess the effectiveness of our website design.
</p>
<p lang="en">
    The company's website uses the following cookies:
</p>
<table width="604" cellpadding="7" cellspacing="0">
    <colgroup>
        <col width="98"/>
        <col width="90"/>
        <col width="372"/>
    </colgroup>
    <tbody>
        <tr valign="top">
            <td width="98">
                <p lang="en">
                    Cookie name
                </p>
            </td>
            <td width="90">
                <p lang="en">
                    Duration
                </p>
            </td>
            <td width="372">
                <p lang="en">
                    Function
                </p>
            </td>
        </tr>
        <tr valign="top">
            <td width="98">
                <p lang="en">
                    _ga
                </p>
            </td>
            <td width="90">
                <p lang="en">
                    2 years
                </p>
            </td>
            <td width="372">
                <p lang="en">
                    Used to distinguish between users.
                </p>
            </td>
        </tr>
        <tr valign="top">
            <td width="98">
                <p lang="en">
                    _gid
                </p>
            </td>
            <td width="90">
                <p lang="en">
                    24 hours
                </p>
            </td>
            <td width="372">
                <p lang="en">
                    Used to distinguish between users.
                </p>
            </td>
        </tr>
        <tr valign="top">
            <td width="98">
                <p lang="en">
                    _gat
                </p>
            </td>
            <td width="90">
                <p lang="en">
                    1 minute
                </p>
            </td>
            <td width="372">
                <p lang="en">
                    Used to regulate access to the website.
                </p>
            </td>
        </tr>
        <tr valign="top">
            <td width="98">
                <p lang="en">
                    _gali
                </p>
            </td>
            <td width="90">
                <p lang="en">
                    24 hours
                </p>
            </td>
            <td width="372">
                <p lang="en">
                    Improved allocation of links.
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p lang="en">
    Users can delete cookies saved by their browser (instructions can be found on the websites of individual browsers).
</p>
<h1 lang="en">
    8) Data protection and data accuracy
</h1>
<p lang="en">
    The company is responsible for information security and infrastructure security (premises and application system software). Our information systems are protected, among other things, with antivirus programs and firewalls. We have introduced appropriate organizational and technical security measures aimed at protecting personal data from accidental or unlawful destruction, loss, alteration, unauthorized disclosure or access, and from other illegal and unauthorized forms of processing. In the case of the transmission of certain types of personal data, we transmit them in encrypted form and protected by a password.
</p>
<p lang="en">
    The individual is responsible for transmitting their personal data securely and for the accuracy and reliability of the transmitted data. The company will strive to keep the personal data it processes accurate and, if necessary, updated, based on the current situation and the purpose of processing the data. Occasionally, we may also contact the individual to confirm the accuracy of their personal data.
</p>
<h1 lang="en">
    9) Individual rights regarding data processing
</h1>
<p lang="en">
    In accordance with the General Data Protection Regulation, the individual has the following rights with regard to data protection:
</p>
<ul>
    <li>
        <p lang="en">
            They may request information about whether we have their personal data and, if so, which data we have and on what basis we have it and why we are using it;
        </p>
    </li>
    <li>
        <p lang="en">
            They may request access to their personal data, which allows them to receive a copy of the personal data that the company holds and verify that the company is processing it legally;
        </p>
    </li>
    <li>
        <p lang="en">
            They may request corrections to their personal data, such as correcting incomplete or inaccurate personal data;
        </p>
    </li>
    <li>
        <p lang="en">
            They may request the deletion of their personal data when there is no reason for further processing or when they exercise their right to object to further processing;
        </p>
    </li>
    <li>
        <p lang="en">
            They may object to the further processing of their personal data where the company relies on a legitimate business interest (including the legitimate interests of a third party), where there are grounds relating to their particular situation; the individual has the right to object at any time to the processing of personal data for direct marketing purposes;
        </p>
    </li>
    <li>
        <p lang="en">
            They may request the restriction of the processing of their personal data, which means suspending the processing of personal data, for example, if the individual wishes the company to establish the accuracy of the personal data or to verify the reasons for further processing of the personal data;
        </p>
    </li>
    <li>
        <p lang="en">
            They may request the transfer of their personal data in a structured, electronic format to another controller, if this is technically possible and feasible;
        </p>
    </li>
    <li>
        <p lang="en">
            They may withdraw their consent or agreement, which they gave for the collection, processing, and transfer of their personal data for a specific purpose; upon receipt of notification that the individual has withdrawn their consent, the company will cease processing the personal data for the purposes for which the original consent was given, unless the company has another legal basis to do so legally.
        </p>
    </li>
</ul>
<p lang="en">
    If an individual wishes to exercise any of the rights listed above, they can send a request by email to <em>sstik@table42.app</em> or by regular mail to the company's address. Access to the individual's personal data and exercised rights is free of charge for the individual. However, the company may charge a reasonable fee if the individual's request, to which the personal data relates, is clearly unfounded or excessive, particularly if it is repetitive. In such cases, the company may also refuse the request. In the event of the exercise of rights under this title, the company may need to request certain information from the individual to help confirm their identity, which is a security measure to ensure that personal data is not disclosed to unauthorized persons.
</p>
<p lang="en">
    In exercising rights under this title, the individual may use the Information Commissioner's form, which is available on their website. Link to: 
    <u>
        <a
            href="https://www.ip-rs.si/fileadmin/user_upload/doc/obrazci/ZVOP/Zahteva_za_seznanitev_z_lastnimi_osebnimi_podatki__Obrazec_SLOP_.doc"
        >
            https://www.ip-rs.si/fileadmin/user_upload/doc/obrazci/ZVOP/Zahteva_za_seznanitev_z_lastnimi_osebnimi_podatki__Obrazec_SLOP_.doc
        </a>
    </u>
</p>
<p lang="en">
    If the individual believes that their rights have been violated, they can turn to the supervisory authority (Information Commissioner) for protection or assistance. Link to: 
    <u>
        <a
            href="https://www.ip-rs.si/zakonodaja/reforma-evropskega-zakonodajnega-okvira-za-varstvo-osebnih-podatkov/kljucna-podrocja-uredbe/prijava-krsitev/"
        >
            https://www.ip-rs.si/zakonodaja/reforma-evropskega-zakonodajnega-okvira-za-varstvo-osebnih-podatkov/kljucna-podrocja-uredbe/prijava-krsitev/
        </a>
    </u>
</p>
<p lang="en">
    If the individual has any questions about the processing of their personal data, they can always contact our company by email at <em>stik@table42.app</em> or by regular mail to the company's address.
</p>
<h1 lang="en">
    10) Changes of notification
</h1>
<p lang="en">
    Any changes to our Personal Data Protection Policy will be posted on the company's websites or applications.
</p>
<p lang="en">
    By using the website, the individual confirms that they accept and agree to the entire content of this personal data protection policy.
</p>
<p lang="en">
    The Personal Data Protection Policy was adopted by Director Mitja Poljšak on September 15, 2022.
</p>
<p lang="en" align="right">
    <strong>Table42 Ltd</strong>
    ,
</p>
<p lang="en" align="right">
    Mitja Poljšak, director
</p>